/**
 * What we show if a feature-flag marks a particular app to be 'unrouteable'
 *
 * TODO: Add link to docs explaining this when you're done writing the docs.
 *
 * TODO: I18n for this page.
 */

import type { FC } from "react";
import React from "react";
import { NavLink } from "react-router-dom";
import { useTimeout } from "../hooks/useTimeout";
import BigCenterMessage from "./BigCenterMessage";
import Loading from "./Loading";

const ComingSoon: FC = () => {
  const [waitedForLoading, setWaitedForLoading] = React.useState(false);
  useTimeout(() => setWaitedForLoading(true), 750);
  if (!waitedForLoading) {
    return <Loading />;
  }

  return (
    <BigCenterMessage
      color="primary"
      heading="This feature's coming soon!"
      data-qa={"coming-soon-splash"}
    >
      <p>
        If you think you should be able to see things here, please{" "}
        <NavLink to={"/help"} title="Contact support">
          contact our support team
        </NavLink>{" "}
        and we&#8217;ll sort it out.
      </p>
    </BigCenterMessage>
  );
};

export default ComingSoon;
